import { React, useState, useEffect } from 'react';
import { Form, Button, Modal } from 'antd';
import { Link, Redirect } from 'react-router-dom';
import 'antd/dist/antd.css';
import style from './auth.module.scss';
import axios from './../../config/apiConfig';
import registerFields from './registerFields.js';
import { CustomButton, FormBuilder } from '../utils/Utils';

const Register = () => {
  const [notHasAccNum, setNotHasAccNum] = useState(false);
  const [isModalNoAccNumVisible, setIsModalNoAccNumVisible] = useState(false);
  const [isModalRegisterDoneVisible, setIsModalRegisterDoneVisible] =
    useState(false);
  const [redirect, setRedirect] = useState(false);
  const [fields, setFields] = useState([]);

  useEffect(() => {
    const fields = registerFields(notHasAccNum, handleCheckBox);
    setFields(fields);
  }, [notHasAccNum]);

  const {
    formLayout,
    justifyCenter,
    justifyEnd,
    modalFooter,
    pModalMarginT,
    register,
  } = style;

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    delete values.passRepeat;

    if (values.accNumber && notHasAccNum) {
      delete values.accNumber;
    }

    try {
      const { data } = await axios.post('/signup', values);
      toggleModal(setIsModalRegisterDoneVisible, isModalRegisterDoneVisible);
      console.log(data); // eslint-disable-line
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo); // eslint-disable-line
  };

  function handleCheckBox(e) {
    setNotHasAccNum(e.target.checked);
  }

  useEffect(() => {
    if (notHasAccNum) {
      form.validateFields(['accNumber']);
      toggleModal(setIsModalNoAccNumVisible, isModalNoAccNumVisible);
    }
  }, [notHasAccNum]);

  const toggleModal = (setState, state) => {
    setState(!state);
    if (setState === setIsModalRegisterDoneVisible && state === true) {
      setRedirect(true);
    }
  };

  return (
    <>
      <div className={formLayout + ' ' + register}>
        <h2>¡Registrate!</h2>
        <Form
          form={form}
          labelCol={{
            span: 12,
          }}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <FormBuilder items={fields} />
          <Form.Item>
            <div className={justifyCenter}>
              <Link to="/signPage">¡Ya tengo cuenta!</Link>
            </div>
          </Form.Item>
          <Form.Item>
            <div className={justifyEnd}>
              <CustomButton htmlType="submit" content="Registrarse" color='btn-dark' size='bg'/>
            </div>
          </Form.Item>
        </Form>
      </div>
      <Modal
        title=""
        visible={isModalNoAccNumVisible}
        footer={null}
        onCancel={() =>
          toggleModal(setIsModalNoAccNumVisible, isModalNoAccNumVisible)
        }
      >
        <p className={pModalMarginT}>
          Si continuas sin proporcionar número de cuenta, no podremos
          identificarte en la base de datos, si en realidad, ya tenias número de
          cuenta.
        </p>
        <div className={modalFooter}>
          <Button
            type="primary"
            onClick={() =>
              toggleModal(setIsModalNoAccNumVisible, isModalNoAccNumVisible)
            }
          >
            Continuar
          </Button>
        </div>
      </Modal>
      <Modal
        title=""
        visible={isModalRegisterDoneVisible}
        footer={null}
        onCancel={() =>
          toggleModal(setIsModalRegisterDoneVisible, isModalRegisterDoneVisible)
        }
      >
        <p className={pModalMarginT}>
          ¡Recibimos tus datos!, pronto te llegara un email a tu correo para
          terminar con el registro.
        </p>
        <div className={modalFooter}>
          <Button
            type="primary"
            onClick={() =>
              toggleModal(
                setIsModalRegisterDoneVisible,
                isModalRegisterDoneVisible,
              )
            }
          >
            Continuar
          </Button>
        </div>
      </Modal>
      {redirect && <Redirect to="/" />}
    </>
  );
};

export default Register;
